import React from 'react';
import {toggleBodyLoader} from './../../helper/custom-function';

const handleDownload = (e, url, fileName) => {
    e.preventDefault();
    try{
        toggleBodyLoader('load');

        if (!url) {
            console.error("Download URL is missing");
            return;
        }

        const urlPath = url.split('?')[0];
        const extension = urlPath.split('.').pop();
        
        const link = document.createElement('a');
        link.href = url;
        
        // Force the filename + extension
        const fullFileName = fileName.endsWith(`.${extension}`) 
            ? fileName 
            : `${fileName}.${extension}`;
        console.log(fullFileName, 'fullFileNamefullFileNamefullFileNamefullFileName')
        link.setAttribute('download', fullFileName);
        link.setAttribute('target', '_blank');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        toggleBodyLoader('remove');
    }catch(error){
        toggleBodyLoader('remove');
    }
};

export {
    handleDownload
};